const API = process.env.REACT_APP_API || "https://api.sharpwithit.vip";
const WS  = API.replace("https://", "wss://").replace("http://", "ws://");

const req = (method, path, body) =>
  fetch(`${API}/api${path}`, {
    method,
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...(body ? { body: JSON.stringify(body) } : {}),
  }).then((r) => {
    if (!r.ok) throw new Error(`${method} ${path} → ${r.status}`);
    return r.json();
  });

export const api = {
  // Auth
  me: () => req("GET", "/auth/me"),
  login: (email, password) => req("POST", "/auth/login", { email, password }),
  logout: () => req("POST", "/auth/logout"),

  // Sites
  getSites:     ()          => req("GET",    "/relaycore/sites"),
  createSite:   (data)      => req("POST",   "/relaycore/sites", data),
  updateSite:   (id, data)  => req("PATCH",  `/relaycore/sites/${id}`, data),
  deleteSite:   (id)        => req("DELETE", `/relaycore/sites/${id}`),

  // Channels
  getChannels:    (siteId)     => req("GET",    `/relaycore/channels${siteId ? `?site_id=${siteId}` : ""}`),
  createChannel:  (data)       => req("POST",   "/relaycore/channels", data),
  updateChannel:  (id, data)   => req("PATCH",  `/relaycore/channels/${id}`, data),
  deleteChannel:  (id)         => req("DELETE", `/relaycore/channels/${id}`),

  // Shifts
  getShifts:    (siteId)     => req("GET",    `/relaycore/shifts${siteId ? `?site_id=${siteId}` : ""}`),
  createShift:  (data)       => req("POST",   "/relaycore/shifts", data),
  updateShift:  (id, data)   => req("PATCH",  `/relaycore/shifts/${id}`, data),

  // Messages
  getMessages:  (chId)       => req("GET",    `/relaycore/channels/${chId}/messages`),
  sendMessage:  (chId, text) => req("POST",   `/relaycore/channels/${chId}/messages`, { text }),

  // Stats / Presence
  getStats:     ()           => req("GET",    "/relaycore/stats"),
  getPresence:  ()           => req("GET",    "/relaycore/presence"),
};

export function createWS(channelId, token, handlers) {
  const url = `${WS}/ws/relaycore/${channelId}?token=${token}`;
  const ws = new WebSocket(url);
  ws.binaryType = "arraybuffer";

  ws.onopen    = () => handlers.onOpen?.();
  ws.onclose   = () => handlers.onClose?.();
  ws.onerror   = (e) => handlers.onError?.(e);
  ws.onmessage = (e) => {
    if (typeof e.data === "string") {
      try { handlers.onEvent?.(JSON.parse(e.data)); }
      catch {}
    } else {
      handlers.onAudio?.(e.data);
    }
  };

  const ping = setInterval(() => {
    if (ws.readyState === WebSocket.OPEN)
      ws.send(JSON.stringify({ type: "ping" }));
  }, 10 * 60 * 1000);

  ws.close_ = ws.close.bind(ws);
  ws.close = () => { clearInterval(ping); ws.close_(); };

  return ws;
}
